import reducer, { actions, selectors, STATE_KEY } from './modules/slice';
import saga from './modules/saga';

export { saga, reducer, actions, selectors };
export const notesStateKey = STATE_KEY;
